import * as contentful from 'contentful'

export const client = contentful.createClient({
    space: 'ycdrm5arknk4',
    accessToken: '0fZH61xliHlKJlvsGRD8VewCr72AmQpxsXnXEOurNas',
})